import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";
import { useContent } from "@/lib/api";

export const FAQ = () => {
  const faqs = useContent("faqs", FAQS);
  return (
    <section id="faq" className="py-24 lg:py-40 bg-paper">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="sticky top-28">
              <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Section · 09 — FAQ</span>
              <h2 className="font-display text-4xl lg:text-5xl text-ink mt-4 leading-[1.05] tracking-[-0.02em]">
                Straight<br/><em className="font-light">answers.</em>
              </h2>
              <p className="mt-6 text-muted-foreground">Still curious? RCCD is one phone call away — no marketing handlers in between.</p>
              <a href="tel:7146374405" className="inline-flex items-center gap-2 mt-6 mono text-[11px] uppercase tracking-[0.22em] text-clay underline-grow">
                (714) 637-4405
              </a>
            </div>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-border">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-border">
                  <AccordionTrigger className="py-6 hover:no-underline group">
                    <div className="flex items-baseline gap-5 text-left">
                      <span className="mono text-[11px] text-clay">{String(i+1).padStart(2,'0')}</span>
                      <span className="font-display text-xl lg:text-2xl text-ink group-hover:text-clay transition-colors text-balance">{f.q}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pl-12 pr-2 pb-6 text-base text-foreground/75 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
